<div class="leads-history-page">
  <app-header></app-header>

  <main class="leads-history-content">
    <!-- Caixa branca com a tabela -->
    <div class="content-box">
      <h2 class="box-title">Histórico de Leads</h2>
      <app-leads-table
        [columns]="tableColumns"
        [data]="tableData"
        [filterConfig]="filterConfig"
        [serverSidePagination]="serverSidePagination"
        [loading]="loading"
        [emptyMessage]="emptyMessage"
        [errorMessage]="errorMessage"
        [viewButtonTracking]="{
          trackEvent: 'visualizar_historico',
          trackCategory: 'historico',
          trackLabel: 'view_historico'
        }"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        (viewLeadClick)="onViewLead($event)"
        (searchChange)="onSearchChange($event)"
        (filterChange)="onFilterChange($event)"
        (filterStatusLeadChange)="onFilterStatusLeadChange($event)"
        (dateRangeChange)="onDateRangeChange($event)"
        (clearAllFilters)="onClearAllFilters()"
        (sortChange)="onSortChange($event)">
      </app-leads-table>
    </div>
  </main>
</div>
